import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {MarketingParams} from "../../../../../common/interfaces/marketing-params.interface";

export interface IRegistrationMarketingData {
    TestData: {
        dl: string;
        dlp: string;
        "orig-lp": string;
        referrer: string;
        //FirebaseAppInstanceID?: string; //this is will be added from IDeviceInfoParameters in additionalParams
        //FirebaseAppID?: string; //this is will be added from IDeviceInfoParameters in additionalParams
        //AppsFlyerID?: string; //this is will be added from IDeviceInfoParameters in additionalParams
        //AppID?: string; //this is will be added from IDeviceInfoParameters in additionalParams
        //DeviceID?: string; //this is will be added from IDeviceInfoParameters in additionalParams
        IDFV?: string;
        [key: string]: any;
    };
    additionalParams?: {
        campaignid: string;
        [key: string]: any;
    };
    sr: string; //this is actually the defaultSerial
}

export class RegistrationMarketingDataBuilder {
    constructor(private readonly services: IServiceFactoryExtended) {
    }

    async buildMarketingData(options?: MarketingParams): Promise<IRegistrationMarketingData> {
        let marketingData = (await this.services.marketing).getMarketingData(options);
        marketingData = await this.services.sdk.getSkin().getSerialData(marketingData);

        marketingData = await this._appendHybridMarketingTestData(marketingData);

        marketingData = await this.services.hybrid.getLexisNexisSession(marketingData);

        return marketingData;

        /*
        const result: any = {};

        Object.keys(marketingData).forEach((key) => {
            if (_.isString(marketingData[key])) {
                result[key] = marketingData[key];
            } else {
                result[key] = JSON.stringify(marketingData[key]);
            }
        });

        return result;
         */
    }

    private async _appendHybridMarketingTestData(marketingData: any): Promise<any> {
        if(!this.services.device.hybrid.inCasino) {
            return marketingData;
        }

        let testData = marketingData.TestData ?? {};
        const hybridTestData = this.services.hybrid.getAppMareketingData();

        marketingData.TestData = {
            ...testData,
            ...hybridTestData
        };
        return marketingData;
    }

}